import { render, staticRenderFns } from "./LostPassword.vue?vue&type=template&id=236bbee4"
import script from "./lostpassword.ts?vue&type=script&lang=js&external"
export * from "./lostpassword.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports